<template>
  <h2 class="flex gap-2 mt-9 mb-4 text-text-primary">
    <Logo />
    Design System
  </h2>
  <!-- Colors -->
  <PageHeader title="Colors" class="my-5 text-text-secondary"></PageHeader>
  <div class="flex flex-col gap-4">
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Primary</h5>
        <div class="flex gap-4">
          <div class="size-20 bg-black flex items-center justify-center text-white p-5">Black</div>
          <div class="size-20 bg-white flex items-center justify-center p-5">White</div>
          <div class="size-20 bg-pink-500 flex items-center justify-center p-5">Magenta</div>
          <div class="size-20 bg-yellow-400 flex items-center justify-center">Yellow</div>
          <div class="size-20 bg-orange-500 flex items-center justify-center">Orange</div>
        </div>
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Neutrals</h5>
        <div class="flex gap-4">
          <div class="size-20 bg-black-50 flex items-center justify-center">50</div>
          <div class="size-20 bg-black-100 flex items-center justify-center">100</div>
          <div class="size-20 bg-black-200 flex items-center justify-center">200</div>
          <div class="size-20 bg-black-300 flex items-center justify-center">300</div>
          <div class="size-20 bg-black-400 flex items-center justify-center">400</div>
          <div class="size-20 bg-black-500 flex items-center justify-center">500</div>
          <div class="size-20 bg-black-600 flex items-center justify-center">600</div>
          <div class="size-20 bg-black-700 flex items-center justify-center">700</div>
          <div class="size-20 bg-black-800 flex items-center justify-center">800</div>
          <div class="size-20 bg-black-900 flex items-center justify-center">900</div>
          <div class="size-20 bg-black-950 flex items-center justify-center">950</div>
        </div>
      </div>
    </div>
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Pink</h5>
        <div class="flex flex-wrap gap-4">
          <div class="size-20 bg-pink-50 flex items-center justify-center">50</div>
          <div class="size-20 bg-pink-100 flex items-center justify-center">100</div>
          <div class="size-20 bg-pink-200 flex items-center justify-center">200</div>
          <div class="size-20 bg-pink-300 flex items-center justify-center">300</div>
          <div class="size-20 bg-pink-400 flex items-center justify-center">400</div>
          <div class="size-20 bg-pink-500 flex items-center justify-center">500</div>
          <div class="size-20 bg-pink-600 flex items-center justify-center">600</div>
          <div class="size-20 bg-pink-700 flex items-center justify-center">700</div>
          <div class="size-20 bg-pink-800 flex items-center justify-center">800</div>
          <div class="size-20 bg-pink-900 flex items-center justify-center">900</div>
          <div class="size-20 bg-pink-950 flex items-center justify-center">950</div>
        </div>
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Yellow</h5>
        <div class="flex flex-wrap gap-4">
          <div class="size-20 bg-yellow-50 flex items-center justify-center">50</div>
          <div class="size-20 bg-yellow-100 flex items-center justify-center">100</div>
          <div class="size-20 bg-yellow-200 flex items-center justify-center">200</div>
          <div class="size-20 bg-yellow-300 flex items-center justify-center">300</div>
          <div class="size-20 bg-yellow-400 flex items-center justify-center">400</div>
          <div class="size-20 bg-yellow-500 flex items-center justify-center">500</div>
          <div class="size-20 bg-yellow-600 flex items-center justify-center">600</div>
          <div class="size-20 bg-yellow-700 flex items-center justify-center">700</div>
          <div class="size-20 bg-yellow-800 flex items-center justify-center">800</div>
          <div class="size-20 bg-yellow-900 flex items-center justify-center">900</div>
          <div class="size-20 bg-yellow-950 flex items-center justify-center">950</div>
        </div>
      </div>
    </div>
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Red</h5>
        <div class="flex flex-wrap gap-4">
          <div class="size-20 bg-red-50 flex items-center justify-center">50</div>
          <div class="size-20 bg-red-100 flex items-center justify-center">100</div>
          <div class="size-20 bg-red-200 flex items-center justify-center">200</div>
          <div class="size-20 bg-red-300 flex items-center justify-center">300</div>
          <div class="size-20 bg-red-400 flex items-center justify-center">400</div>
          <div class="size-20 bg-red-500 flex items-center justify-center">500</div>
          <div class="size-20 bg-red-600 flex items-center justify-center">600</div>
          <div class="size-20 bg-red-700 flex items-center justify-center">700</div>
          <div class="size-20 bg-red-800 flex items-center justify-center">800</div>
          <div class="size-20 bg-red-900 flex items-center justify-center">900</div>
          <div class="size-20 bg-red-950 flex items-center justify-center">950</div>
        </div>
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Green</h5>
        <div class="flex flex-wrap gap-4">
          <div class="size-20 bg-green-50 flex items-center justify-center">50</div>
          <div class="size-20 bg-green-100 flex items-center justify-center">100</div>
          <div class="size-20 bg-green-200 flex items-center justify-center">200</div>
          <div class="size-20 bg-green-300 flex items-center justify-center">300</div>
          <div class="size-20 bg-green-400 flex items-center justify-center">400</div>
          <div class="size-20 bg-green-500 flex items-center justify-center">500</div>
          <div class="size-20 bg-green-600 flex items-center justify-center">600</div>
          <div class="size-20 bg-green-700 flex items-center justify-center">700</div>
          <div class="size-20 bg-green-800 flex items-center justify-center">800</div>
          <div class="size-20 bg-green-900 flex items-center justify-center">900</div>
          <div class="size-20 bg-green-950 flex items-center justify-center">950</div>
        </div>
      </div>
    </div>
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Orange</h5>
        <div class="flex flex-wrap gap-4">
          <div class="size-20 bg-orange-50 flex items-center justify-center">50</div>
          <div class="size-20 bg-orange-100 flex items-center justify-center">100</div>
          <div class="size-20 bg-orange-200 flex items-center justify-center">200</div>
          <div class="size-20 bg-orange-300 flex items-center justify-center">300</div>
          <div class="size-20 bg-orange-400 flex items-center justify-center">400</div>
          <div class="size-20 bg-orange-500 flex items-center justify-center">500</div>
          <div class="size-20 bg-orange-600 flex items-center justify-center">600</div>
          <div class="size-20 bg-orange-700 flex items-center justify-center">700</div>
          <div class="size-20 bg-orange-800 flex items-center justify-center">800</div>
          <div class="size-20 bg-orange-900 flex items-center justify-center">900</div>
          <div class="size-20 bg-orange-950 flex items-center justify-center">950</div>
        </div>
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Blue</h5>
        <div class="flex flex-wrap gap-4">
          <div class="size-20 bg-blue-50 flex items-center justify-center">50</div>
          <div class="size-20 bg-blue-100 flex items-center justify-center">100</div>
          <div class="size-20 bg-blue-200 flex items-center justify-center">200</div>
          <div class="size-20 bg-blue-300 flex items-center justify-center">300</div>
          <div class="size-20 bg-blue-400 flex items-center justify-center">400</div>
          <div class="size-20 bg-blue-500 flex items-center justify-center">500</div>
          <div class="size-20 bg-blue-600 flex items-center justify-center">600</div>
          <div class="size-20 bg-blue-700 flex items-center justify-center">700</div>
          <div class="size-20 bg-blue-800 flex items-center justify-center">800</div>
          <div class="size-20 bg-blue-900 flex items-center justify-center">900</div>
          <div class="size-20 bg-blue-950 flex items-center justify-center">950</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Typography -->
  <PageHeader title="Typography" class="my-5 text-text-secondary"></PageHeader>
  <div class="flex flex-col gap-4">
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-8 text-text-secondary">Headings</h5>
        <div class="flex flex-col gap-8 text-text-primary">
          <h2 class="text-heading-xs">
            <span class="text-lg text-text-secondary mr-4">xsmall</span>The quick brown fox jumps
            over the lazy dog
          </h2>
          <h2 class="text-heading-sm leading-tight">
            <span class="text-lg text-text-secondary mr-4">small</span>The quick brown fox jumps
            over the lazy dog
          </h2>
          <h2 class="text-heading-md leading-tight">
            <span class="text-lg text-pink-500 mr-4">default</span>The quick brown fox jumps over
            the lazy dog
          </h2>
          <h2 class="text-heading-lg leading-tight">
            <span class="text-lg text-text-secondary mr-4">large</span>The quick brown fox jumps
            over the lazy dog
          </h2>
          <h2 class="text-heading-xl leading-tight">
            <span class="text-lg text-text-secondary mr-4">xlarge</span>The quick brown fox jumps
            over the lazy dog
          </h2>
          <h2 class="text-heading-xxl leading-tight">
            <span class="text-lg text-text-secondary mr-4">xxlarge</span>The quick brown fox jumps
            over the lazy dog
          </h2>
        </div>
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-8 text-text-secondary">Body</h5>
        <div class="flex flex-col gap-4 text-text-primary">
          <p class="text-sm">
            <span class="text-lg text-text-secondary mr-2">small</span>The quick brown fox jumps
            over the lazy dog
          </p>
          <p class="text-base">
            <span class="text-lg text-pink-500 mr-2">default</span>The quick brown fox jumps over
            the lazy dog
          </p>
          <p class="text-lg">
            <span class="text-lg text-text-secondary mr-2">large</span>The quick brown fox jumps
            over the lazy dog
          </p>
          <p class="text-xl">
            <span class="text-lg text-text-secondary mr-2">xlarge</span>The quick brown fox jumps
            over the lazy dog
          </p>
          <div class="">
            <span class="text-lg mr-2 text-pink-500 no-underline">link</span
            ><a href="" class="text-link-main">The quick brown fox jumps over the lazy dog </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Spacing and sizing -->
  <PageHeader title="Spacing and Sizing" class="my-5 text-text-secondary"></PageHeader>
  <div class="flex flex-col gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <div class="flex gap-4 text-text-primary items-center">
        <div class="flex flex-col items-center gap-2">
          <span>2</span>
          <div class="w-base-2 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>4</span>
          <div class="w-base-4 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>6</span>
          <div class="w-base-6 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>8</span>
          <div class="w-base-8 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>16</span>
          <div class="w-base-16 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>24</span>
          <div class="w-base-24 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>32</span>
          <div class="w-base-32 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>40</span>
          <div class="w-base-40 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>48</span>
          <div class="w-base-48 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>56</span>
          <div class="w-base-56 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>64</span>
          <div class="w-base-64 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>72</span>
          <div class="w-base-72 h-6 bg-pink-500"></div>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span>80</span>
          <div class="w-base-80 h-6 bg-pink-500"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Button -->
  <PageHeader title="Button" class="my-5 text-text-secondary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Button Variantions</h5>
      <div class="flex flex-col gap-4">
        <Button unstyled class="button button-primary button-md">Primary</Button>
        <Button unstyled class="button button-outlined" label="Outlined" />
        <Button unstyled class="button button-danger" label="Danger" />
        <Button unstyled class="button button-warning" label="Warning" />
        <Button unstyled class="button button-success" label="Success" />
        <Button unstyled class="button button-text" label="Text" />

        <Button unstyled class="button button-pink" label="Pink" />
        <Button unstyled class="button button-informative" label="Informative" />
        <Button unstyled class="button button-tonal" label="Tonal" />
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Button Danger</h5>
        <div class="flex flex-wrap items-center gap-2">
          <Button unstyled class="button button-danger">Default</Button>
          <Button unstyled class="button button-danger-outlined">Outlined</Button>
          <Button unstyled class="button button-danger-text">Text</Button>
          <Button unstyled class="button button-danger-tonal">Tonal</Button>
        </div>
      </div>
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Button Warning</h5>
        <div class="flex flex-wrap items-center gap-2">
          <Button unstyled class="button button-warning">Default</Button>
          <Button unstyled class="button button-warning-outlined">Outlined</Button>
          <Button unstyled class="button button-warning-text">Text</Button>
          <Button unstyled class="button button-warning-tonal">Tonal</Button>
        </div>
      </div>
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Button Success</h5>
        <div class="flex flex-wrap items-center gap-2">
          <Button unstyled class="button button-success">Default</Button>
          <Button unstyled class="button button-success-outlined">Outlined</Button>
          <Button unstyled class="button button-success-text">Text</Button>
          <Button unstyled class="button button-success-tonal">Tonal</Button>
        </div>
      </div>
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Button Informative</h5>
        <div class="flex flex-wrap items-center gap-2">
          <Button unstyled class="button button-informative">Default</Button>
          <Button unstyled class="button button-informative-outlined">Outlined</Button>
          <Button unstyled class="button button-informative-text">Text</Button>
          <Button unstyled class="button button-informative-tonal">Tonal</Button>
        </div>
      </div>
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Button Pink</h5>
        <div class="flex flex-wrap items-center gap-2">
          <Button unstyled class="button button-pink">Default</Button>
          <Button unstyled class="button button-pink-outlined">Outlined</Button>
          <Button unstyled class="button button-pink-text">Text</Button>
          <Button unstyled class="button button-pink-tonal">Tonal</Button>
        </div>
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Button Sizes</h5>
      <div class="flex flex-wrap items-center gap-2">
        <Button unstyled class="button button-primary button-sm">Button</Button>
        <Button unstyled class="button button-primary button-md">Button</Button>
        <Button unstyled class="button button-primary button-lg">Button</Button>
      </div>
    </div>
  </div>
  <!-- Switch -->
  <PageHeader title="Switch" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Switch Variations</h5>
      <div class="flex flex-wrap items-center gap-4">
        <ToggleSwitch v-model="toggle" type="success" text="Success" />
        <ToggleSwitch v-model="toggle" type="danger" text="Danger" />
        <ToggleSwitch v-model="toggle" type="warning" text="Warning" />
        <ToggleSwitch v-model="toggle" type="secondary" text="Secondary" />
        <ToggleSwitch v-model="toggle" type="pink" text="Pink" />
        <ToggleSwitch v-model="toggle" type="primary" text="Primary" />
        <ToggleSwitch type="primary" disabled text="Disabled" />
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full flex flex-col"
    >
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Switch Text Direction - Top</h5>
        <div class="flex flex-wrap items-center gap-2">
          <ToggleSwitch
            v-model="toggle"
            text="Label here"
            type="success"
            direction="top"
          ></ToggleSwitch>
        </div>
      </div>
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Switch Text Direction - Bottom</h5>
        <div class="flex flex-wrap items-center gap-2">
          <ToggleSwitch
            v-model="toggle"
            text="Label here"
            type="success"
            direction="bottom"
          ></ToggleSwitch>
        </div>
      </div>
      <div class="mb-5">
        <h5 class="mb-5 text-text-secondary">Switch Text Direction - Left</h5>
        <div class="flex flex-wrap items-center gap-2">
          <ToggleSwitch v-model="toggle" text="Label Here" type="success" direction="left"
            >Left</ToggleSwitch
          >
        </div>
      </div>
    </div>
  </div>

  <!-- Tags -->
  <PageHeader title="Tag" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <div class="flex flex-wrap gap-6 justify-center">
        <div class="flex gap-4 flex-col">
          <h5 class="mb-5 text-text-secondary">Primary</h5>
          <Tag unstyled value="Tag primary" class="tag tag-primary" />
          <Tag unstyled value="Tag primary outlined" class="tag tag-primary-outlined" />
          <Tag unstyled value="Tag primary Ghost" class="tag tag-primary-ghost" />
        </div>

        <div class="flex gap-4 flex-col">
          <h5 class="mb-5 text-text-secondary">Secondary</h5>
          <Tag unstyled value="Secondary Tag" class="tag tag-secondary" />
          <Tag unstyled value="Secondary Tag Outlined" class="tag tag-secondary-outlined" />
        </div>

        <div class="flex gap-4 flex-col">
          <h5 class="mb-5 text-text-secondary">Pink</h5>
          <Tag unstyled value="Pink Tag" class="tag tag-pink" />
          <Tag unstyled value="Pink Tag Outlined" class="tag tag-pink-outlined" />
          <Tag unstyled value="Pink Tag Ghost" class="tag tag-pink-ghost" />
        </div>

        <div class="flex gap-4 flex-col">
          <h5 class="mb-5 text-text-secondary">Success</h5>
          <Tag unstyled value="Success Tag" class="tag tag-success" />
          <Tag unstyled value="Success Tag Outlined" class="tag tag-success-outlined" />
          <Tag unstyled value="Success Tag Ghost" class="tag tag-success-ghost" />
        </div>

        <div class="flex gap-4 flex-col">
          <h5 class="mb-5 text-text-secondary">Warning</h5>
          <Tag unstyled value="Warning Tag" class="tag tag-warning" />
          <Tag unstyled value="Warning Tag Outlined" class="tag tag-warning-outlined" />
          <Tag unstyled value="Warning Tag Ghost" class="tag tag-warning-ghost" />
        </div>

        <div class="flex gap-4 flex-col">
          <h5 class="mb-5 text-text-secondary">Danger</h5>
          <Tag unstyled value="Danger Tag" class="tag tag-danger" />
          <Tag unstyled value="Danger Tag Outlined" class="tag tag-danger-outlined" />
          <Tag unstyled value="Danger Tag Ghost" class="tag tag-danger-ghost" />
        </div>
      </div>
    </div>
  </div>

  <!-- Checkbox -->
  <PageHeader title="Checkbox" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Checkbox Variations</h5>
      <div class="flex flex-col gap-4">
        <Checkbox :binary="true" v-model="toggle"> Checkbox Default </Checkbox>
        <Checkbox type="primary" :binary="true" v-model="toggle" hint="Hint goes here">
          Checkbox Primary
        </Checkbox>
        <Checkbox type="danger" :binary="true" v-model="toggle" hint="Hint goes here">
          Checkbox Danger
        </Checkbox>
        <Checkbox type="success" :binary="true" v-model="toggle" hint="Hint goes here">
          Checkbox Success
        </Checkbox>
        <Checkbox type="warning" :binary="true" v-model="toggle" hint="Hint goes here">
          Checkbox Warning
        </Checkbox>
        <Checkbox :binary="true" v-model="toggle" disabled hint="Hint goes here">
          Checkbox Disabled
        </Checkbox>
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Checkbox Intermediate</h5>
      <div class="flex flex-col gap-5">
        <Checkbox :binary="true" v-model="toggle" intermediate>
          Checkbox Default Intermediate</Checkbox
        >
        <Checkbox :binary="true" intermediate v-model="toggle" hint="Hint goes here">
          Checkbox Primary Intermediate
        </Checkbox>
        <Checkbox type="danger" :binary="true" intermediate v-model="toggle" hint="Hint goes here">
          Checkbox Danger Intermediate
        </Checkbox>
        <Checkbox type="warning" :binary="true" intermediate v-model="toggle" hint="Hint goes here">
          Checkbox Warning Intermediate
        </Checkbox>
        <Checkbox type="success" :binary="true" intermediate v-model="toggle" hint="Hint goes here">
          Checkbox Success Intermediate
        </Checkbox>
      </div>
    </div>
    <div class="flex gap-4 flex-col w-full">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <div class="flex flex-col mb-6">
          <h5 class="mb-5 text-text-secondary">Checkbox Sizes</h5>
          <div class="flex flex-col gap-4">
            <Checkbox :binary="true" v-model="toggle" size="sm"> Checkbox Primary SM </Checkbox>
            <Checkbox :binary="true" v-model="toggle" size="md"> Checkbox Primary MD </Checkbox>
            <Checkbox :binary="true" v-model="toggle" size="lg"> Checkbox Primary LG </Checkbox>
          </div>
        </div>
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Checkbox Icon Alignment</h5>
        <div class="flex items-start gap-4 flex-col">
          <Checkbox :binary="true" v-model="toggle" iconAlignment="right">
            Icon alignment right
          </Checkbox>
          <Checkbox :binary="true" v-model="toggle" iconAlignment="top">
            Icon alignment top
          </Checkbox>
          <Checkbox :binary="true" v-model="toggle" iconAlignment="bottom">
            Icon alignment bottom
          </Checkbox>
        </div>
      </div>
    </div>
  </div>

  <!-- Radio Button -->
  <PageHeader title="Radio Button" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Radio Button Variations</h5>
      <div class="flex flex-col gap-4">
        <RadioButton type="primary" :value="true" v-model="radio">Primary</RadioButton>
        <RadioButton type="danger" :value="false" v-model="radio">Danger</RadioButton>
        <RadioButton type="success" :value="true" v-model="radio">Success</RadioButton>
        <RadioButton type="warning" :value="false" v-model="radio">Warning</RadioButton>
        <RadioButton disabled :value="true">Disabled</RadioButton>
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Radio Button Alignment</h5>
      <div class="flex flex-col gap-5">
        <RadioButton type="primary" :value="false" v-model="radio" iconAlignment="bottom"
          >Icon alignment bottom</RadioButton
        >
        <RadioButton type="primary" :value="true" v-model="radio" iconAlignment="top"
          >Icon alignment top</RadioButton
        >
        <RadioButton type="primary" iconAlignment="top" disabled
          >Icon alignment topdisabled</RadioButton
        >
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Radio Button Sizes</h5>
      <div class="flex flex-col gap-5">
        <RadioButton type="primary" :value="true" v-model="radio" hint="SM" size="sm" />
        <RadioButton type="primary" :value="true" v-model="radio" hint="MD" size="md" />
        <RadioButton type="primary" :value="true" v-model="radio" hint="LG" size="lg" />
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <PageHeader title="Tabs" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <Tabs unstyled :value="activeStatus">
        <TabList unstyled>
          <Tab
            unstyled
            :pt="{
              root: ({ context }) => {
                return {
                  class: 'tab-item' + (context.active ? ' item-active' : ''),
                };
              },
            }"
            v-for="tab in items"
            :key="tab.label"
            :value="tab.value"
            >{{ tab.label }}</Tab
          >
        </TabList>
      </Tabs>
    </div>
  </div>

  <!-- Alert -->
  <PageHeader title="Alert" class="my-5 text-text-primary"></PageHeader>
  <div class="flex flex-col gap-4">
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Alert Filled</h5>
        <div class="flex flex-col gap-4">
          <Alert text="Alert default" description="Description" />
          <Alert text="Alert informative" description="Description" type="informative" />
          <Alert text="Alert warning" description="Description" type="warning" />
          <Alert text="Alert danger" description="Description" type="danger" />
        </div>
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Alert Outlined</h5>
        <div class="flex flex-col gap-4">
          <Alert text="Alert outlined default" description="Description" isOutlined />
          <Alert
            text="Alert informative outlined"
            description="Description"
            type="informative"
            isOutlined
          />
          <Alert
            text="Alert warning outlined"
            description="Description"
            type="warning"
            isOutlined
          />
          <Alert text="Alert danger outlined" description="Description" type="danger" isOutlined />
        </div>
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Alert with 'close' text</h5>
      <div class="flex flex-col gap-4">
        <Alert text="Alert with close text" description="Description" type="danger" closeText />
      </div>
    </div>
  </div>

  <!-- Textarea -->
  <PageHeader title="Textarea" class="my-5 text-text-primary"></PageHeader>
  <div class="flex flex-col gap-4">
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Default textarea</h5>
        <TextArea />
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Default textarea with message and info text</h5>
        <TextArea
          infoTop="Info at the top of text area"
          message="Your message here"
          infoBottom="A note for extra info"
        />
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Disabled textarea</h5>
        <TextArea message="Message" placeholder="Placeholder" disabled />
      </div>
    </div>
    <div class="flex gap-4">
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Auto resize textarea</h5>
        <TextArea
          infoTop="Info at the top of text area"
          message="Message"
          placeholder="Placeholder here"
          rows="5"
        />
      </div>
      <div
        class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
      >
        <h5 class="mb-5 text-text-secondary">Auto resize disabled textarea</h5>
        <TextArea message="Message" placeholder="Placeholder here" :autoResize="false" />
      </div>
    </div>
  </div>

  <!-- Input text -->
  <PageHeader title="Input text" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text default</h5>
        <InputText
          id="email"
          name="email"
          type="text"
          v-model="email"
          placeholder="Your e-mail"
          :searchIcon="false"
        />
      </div>
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text with labels</h5>
        <InputText
          labelName="Label text"
          id="email"
          name="email"
          type="text"
          v-model="email"
          placeholder="Your e-mail"
          extraInfo="Extra info here"
        />
      </div>
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text with loading</h5>
        <InputText
          id="email"
          name="email"
          type="text"
          v-model="email"
          placeholder="Your e-mail"
          :loading="true"
          :searchIcon="true"
        />
      </div>
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text with search icon</h5>
        <InputText
          id="email"
          name="email"
          type="text"
          v-model="email2"
          placeholder="Your e-mail"
          :searchIcon="true"
        />
      </div>
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text with Left Icon</h5>
        <InputText
          id="email"
          name="email"
          type="text"
          v-model="email"
          placeholder="Your e-mail"
          :searchIcon="true"
          :left-icon="true"
        />
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text disabled</h5>
        <InputText
          id="email"
          name="email"
          type="text"
          disabled
          v-model="email2"
          placeholder="Disabled"
        />
      </div>
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text invalid state</h5>
        <InputText
          id="email"
          name="email"
          type="text"
          wrapperClass="input-text-error"
          v-model="email2"
          placeholder="Invalid State"
        />
      </div>
      <div class="flex flex-col mb-5">
        <h5 class="mb-5 text-text-secondary">Input text valid state</h5>
        <InputText
          id="email"
          name="email"
          type="text"
          v-model="email2"
          wrapperClass="input-text-success"
          placeholder="Valid State"
          isValid
        />
      </div>
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">Input text sizes</h5>
      <div class="flex flex-col gap-4">
        <InputText
          id="email"
          name="email"
          type="text"
          size="sm"
          v-model="email2"
          placeholder="Small"
        />
        <InputText
          id="email"
          name="email"
          type="text"
          v-model="email2"
          placeholder="Medium - default"
        />
        <InputText
          id="email"
          name="email"
          type="text"
          size="lg"
          v-model="email2"
          placeholder="Large"
        />
      </div>
    </div>
  </div>

  <!-- File upload -->
  <PageHeader title="File Upload" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">File Upload Inline</h5>
      <div class="file-upload-inline-wrapper flex p-0">
        <input type="file" id="actual-btn" hidden />
        <label for="actual-btn" class="file-upload-inline-label">Choose File</label>
        <span id="file-chosen" class="file-upload-inline-placeholder flex items-center"
          >No file chosen</span
        >
      </div>
    </div>

    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">File Upload Default</h5>
      <FileUpload
        class="file-upload"
        id="productChangeRequestFile"
        name="productChangeRequestFile"
      />
    </div>
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <h5 class="mb-5 text-text-secondary">File Upload with Subtitle</h5>
      <FileUpload
        class="file-upload"
        id="productChangeRequestFile"
        name="productChangeRequestFile"
        file-subtitle="File subtitle here"
      />
    </div>
  </div>

  <!-- Accordion -->
  <PageHeader title="Accordion" class="my-5 text-text-primary"></PageHeader>
  <div class="flex gap-4">
    <div
      class="bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10 w-full"
    >
      <Accordion
        expandIcon="pi pi-plus-circle"
        collapseIcon="pi pi-minus-circle"
        unstyled
        :multiple="true"
      >
        <AccordionPanel
          :pt="{
            root: { class: 'accordion accordion-primary' },
          }"
          v-for="faq in faqs"
          :key="faq.question"
          :value="faq.num"
        >
          <AccordionHeader
            :pt="{
              toggleicon: { class: 'accordion-header-icon' },
              root: { class: 'accordion-header' },
            }"
            >{{ faq.question }}</AccordionHeader
          >
          <AccordionContent
            :pt="{
              content: { class: 'accordion-content' },
            }"
          >
            <p v-if="faq.html" v-dompurify-html="faq.answer"></p>
            <p v-else>{{ faq.answer }}</p>
          </AccordionContent>
        </AccordionPanel>
      </Accordion>
    </div>
  </div>

  <!-- Tooltip -->
  <PageHeader title="Tooltip" class="my-5 text-text-primary"></PageHeader>
  <div
    class="flex flex-col gap-10 mb-40 bg-background-bg-primary border border-borders-border-secondary rounded-xl p-10"
  >
    <h5 class="mb-5 text-text-secondary">Tooltip Variations</h5>
    <div class="flex gap-4">
      <Button
        unstyled
        v-tooltip.top="{
          value: 'Tooltip Top Position',
          autoHide: false,
          pt: {
            root: 'tooltip',
          },
        }"
        class="button button-tonal"
        label="Tooltip Top"
      />
      <Button
        unstyled
        v-tooltip.bottom="{
          value: 'Tooltip Bottom',
          autoHide: false,
          pt: {
            root: 'tooltip',
          },
        }"
        class="button button-tonal"
        label="Tooltip Bottom"
      />
      <Button
        unstyled
        v-tooltip.left="{
          value: 'Tooltip Left',
          autoHide: false,
          pt: {
            root: 'tooltip',
          },
        }"
        class="button button-tonal"
        label="Tooltip Left"
      />
      <Button
        unstyled
        v-tooltip.right="{
          value: 'Tooltip Right',
          autoHide: false,
          pt: {
            root: 'tooltip',
          },
        }"
        class="button button-tonal"
        label="Tooltip Right"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Button from "primevue/button";
import ToggleSwitch from "@/components/elements/ToggleSwitch.vue";
import Tag from "primevue/tag";
import Checkbox from "@/components/elements/Checkbox.vue";
import RadioButton from "@/components/elements/RadioButton.vue";
import Alert from "@/components/elements/Alert.vue";
import TextArea from "@/components/elements/TextArea.vue";
import InputText from "@/components/elements/InputText.vue";
import PageHeader from "@/components/elements/PageHeader.vue";
import Logo from "@/components/svg/Logo.vue";
import Tabs from "primevue/tabs";
import TabList from "primevue/tablist";
import Tab from "primevue/tab";
import FileUpload from "@/components/elements/FileUpload.vue";
import Accordion from "primevue/accordion";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";

const toggle = ref(false);
const radio = ref(false);
const email = ref("");
const email2 = ref("");
const activeStatus = ref(0);
const faqs = ref([
  {
    num: 1,
    question: "Why is the number of Value Rights created higher than the subscription amount?",
    answer: `Additional Value Rights are created on the exchange to facilitate the expected secondary market trading. The oversize is estimated based on the product type (AMC, Tracker, CLN) and the secondary market frequency determined in the Termsheet. Keeping the oversize allows to process any subsequent small subscriptions faster.
          The additional value rights on top of the number of outstanding certificates are not considered for the valuation/NAV calculation of the products. `,
  },
  {
    num: 2,
    html: true,
    question:
      "How are set-up fees and distribution fees priced into valuations? What about other fees such as management or administration fees?",
    answer: `Set-up Fees are typically applied only to the subscribed size in the primary market (and not the secondary market). Distribution Fees, on the other hand, could be applied to primary or secondary market transactions (if disclosed in the Termsheet).
          Any Management or Administration Fees would accrue on a daily basis as of Issue Date, including weekends and public holidays. Gross Asset levels are kept flat over weekends as well as on specific Swiss public holidays.
          On Issue Date, the first accrued fee will be calculated as such:
          <br>
            <ul style="list-style-type: unset; padding: revert">
              <li>Daily Fee (Issue Date) = (Fee % p.a. / 365) * Number of Certificates (Issue Date) * Issue Price</li>
            </ul>
            For any subsequent day, the accrued daily fee balance on day T is calculated based on the formula below:
            <ul style="list-style-type: unset; padding: revert">
                <li>Accrued Daily Fee (T) = (Fee % p.a. / 365) * Number of Certificates (T) * NAV (T-1) + Accrued Daily Fee (T-1) – Fee Paid (T)</li>
            </ul>
          The historical NAVs reported to Telekurs and the Number of Outstanding Certificates, as well as the applicable running fee %, are available on <a href="https://app.gentwo.com/products">GenTwo Products</a>
          <br>
          An illustrative simple example in Excel can be visualized <a href="/docs/Quarterly_Fee_Calculation_Example_FAQ.xlsx">here</a>.
          `,
  },
]);
const items = ref([
  {
    label: "Pending",
    value: "PendingWithCurrentUser",
  },
  {
    label: "Active",
    value: "Runnable",
  },
  {
    label: "Complete",
    value: "Complete",
  },
  {
    label: "Terminated",
    value: "Terminated",
  },
  {
    label: "All",
    value: "All",
  },
]);
</script>
